<script setup>
import {computed} from 'vue';
import InputLabel from "@/Components/InputLabel.vue";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    modelValue: Object | Number,
    title: String,
    disabled: Boolean,
    items: Array,
    titleField: String | undefined,
    emptyTitle: String | undefined,
    hasError: Boolean | undefined,
    value: {
        type: String,
        default: 'id'
    },
    width: {
        type: String,
        default: 'auto'
    },
    defaultItem: {
        type: Boolean,
        default: true
    }
});

const widthClass = computed(() => {
    return {
        'auto': 'w-auto',
        'full': 'w-full',
        '12.5': 'w-[12.5rem]',
        '1/2': 'w-1/2'
    }[props.width];
});


const selectItems = computed(() => {
    const emptyObj = {id: null, [props.titleField ?? 'title']: props.emptyTitle ?? trans('Select')};
    if(!emptyObj.value) {
        emptyObj['value'] = undefined
    }
    return props.defaultItem ? [emptyObj, ...props.items] : props.items

});

const emit = defineEmits(['update:modelValue']);

// const input = ref(null);

// onMounted(() => {
//   if (input.value.hasAttribute('autofocus')) {
//     input.value.focus();
//   }
// });

// defineExpose({focus: () => input.value.focus()});
const onSelect = (e) => {
    emit('update:modelValue', selectItems.value[e.target.value][props.value])
}
const value = computed(() => {
    let val = selectItems.value.findIndex(item => {
        const value = item[props.value] ? item[props.value] : item.id;
        if (value === props.modelValue) {
            return item;
        }
    })
    if(props.modelValue) {
        return val;
    } else {
        return 0
    }
})
</script>

<template>
    <div class="flex justify-between py-1.25">
        <InputLabel v-if="title" :class="{'text-red-500': hasError}" :value="title"
                    class="font-sans font-medium text-black dark:text-slate-200 flex items-center uppercase"
        />
        <select
            :class="[{'border-red-300': hasError, 'text-red-500': hasError }, widthClass]"
            :disabled="disabled"
            class="border-gray-300 dark:border-slate-600 dark:bg-dark-blue dark:text-slate-200 focus:border-blue-600 focus:ring-blue-600 rounded-md shadow-sm"
            @input="onSelect"
            :value="value"
        >
            <option v-for="(item, index) in selectItems" :value="index">{{
                    titleField ? item[titleField] : item.title
                }}
            </option>
        </select>
    </div>
</template>
